import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { CheckboxActiveIcon } from 'assets/icons/checkbox-active';
import { CheckboxNonActiveIcon } from 'assets/icons/checkbox-non-active';
import { cn } from 'utils';

interface AgGridCheckboxRendererProps extends ICellRendererParams {
  value: boolean;
  label?: string | number;
  disabled?: boolean;
}

const AgGridCheckboxRenderer: React.FC<AgGridCheckboxRendererProps> = ({
  value,
  label,
  node,
  column,
  disabled,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      return;
    }

    e.stopPropagation();
    const newValue = !value;
    if (column) {
      node.setDataValue(column.getColId(), newValue);
    }
  };

  return (
    <div
      className={cn(
        'flex items-center gap-2 w-full h-full',
        !label && 'justify-center'
      )}
      onClick={handleClick}
    >
      <div className="relative cursor-pointer">
        <input
          type="checkbox"
          checked={value}
          disabled={disabled}
          className="absolute opacity-0 h-5 w-5"
          readOnly
        />
        {value ? <CheckboxActiveIcon /> : <CheckboxNonActiveIcon />}
      </div>
      {label && <span className="select-none">{label}</span>}
    </div>
  );
};

export default AgGridCheckboxRenderer;
